export const parseFlightSearchTraveller = ({ passengers, seatedInfant }) => {
  return {
    adults: passengers?.adult || 0,
    children: passengers?.child || 0,
    infants: seatedInfant ? passengers?.infant || 0 : 0,
    held_infant: !seatedInfant ? passengers?.infant || 0 : 0,
  };
};

export const parseFlightRoutesAndTripType = ({ destinations }) => {
  let description = "";
  let routes = "";
  if (destinations?.length === 0 || !destinations) {
  } else if (destinations?.length === 1) {
    description = "One way";
    routes = `${destinations?.at(0)?.from} - ${destinations?.at(0)?.to}`;
  } else if (destinations?.at(0)?.from === destinations?.at(1)?.to) {
    description = "Round trip";
    routes = `${destinations?.at(0)?.from} - ${destinations?.at(0)?.to}`;
  } else {
    description = "Multi city";
    routes = destinations
      ?.map((flight, index) => {
        if (index === destinations?.length - 1)
          return `${flight?.from} - ${flight?.to}`;
        return flight?.from;
      })
      ?.join(" - ");
  }
  return {
    tripType: description,
    routes,
  };
};
